export const notificationsStatus = {
  new: 0,
  read: 1,
  deleted: 2,
}